import { json } from 'react-router-dom';
import { setupLabID } from './labSetup';

let LabID = sessionStorage.getItem("LABID");

const callingURL=window.location.hostname;
const URLArray=callingURL.split('.');
let LabIDl=URLArray[0].split('-');
let environ=LabIDl[1];
// console.log(LabIDl);
const rootDTCAPIURL1 = "https://www.lpwebcalls.com/api/lifepoint/patientconnect/";
let rootDTCAPIURL = "https://www.lpwebcalls.com/api/lifepoint/patientconnect/demo/consumer/";
let rootSHAPIURL = "https://www.lpwebcalls.com/api/lifepoint/patientconnect/demo/schedule/";
if(environ==='test' || process.env.NODE_ENV !== 'production' || LabID === 'LOCALHOST') {
	rootDTCAPIURL = rootDTCAPIURL1 + 'demo/consumer/';
	rootSHAPIURL = rootDTCAPIURL1 +'demo/schedule/';
}else{
	rootDTCAPIURL = rootDTCAPIURL1 + 'live/consumer/';
	rootSHAPIURL = rootDTCAPIURL1 +'live/schedule/';
}
if (process.env.NODE_ENV !== 'production' || LabID === 'LOCALHOST') {
	LabID = process.env.REACT_APP_LABID;
}
const urlParams=window.location.href;
let urlParamsArray= urlParams.split('?');
const urlType=urlParamsArray[1];
function convertDate(dateString){
	var p = dateString.split(/\D/g);
	return [p[1],p[2],p[0] ].join("-")
	}
function convertDate2(dateString){
	var MyDateString = ('0' + dateString.getDate()).slice(-2) + '/'
             + ('0' + (dateString.getMonth()+1)).slice(-2) + '/'
             + dateString.getFullYear();
	var p = MyDateString.split(/\D/g);
	return [p[1],p[0],p[2] ].join("-")
	}
const pad = n => String(n).padStart(2, "0");
function formatDisplayDate(d) {
  let hours = d.getUTCHours();
  const ampm = hours >= 12 ? "pm" : "am";

  // convert 24h → 12h
  hours = hours % 12;
  hours = hours ? hours : 12; // 0 → 12

  const time = `${hours}:${pad(d.getUTCMinutes())} ${ampm}`;
  const date = `${pad(d.getUTCMonth() + 1)}-${pad(d.getUTCDate())}-${d.getUTCFullYear()}`;

  return `${date} ${time} `;
}
export const backEndTest = async() =>{
		let DTCBACKENDSERVER = await getLabConfig("DTCBACKENDSERVER");
		let LabID=sessionStorage.getItem("LABID");
		const ccURL=`${DTCBACKENDSERVER}/lifepoint/checkBackend?LabID=`+LabID;
		const options= { method: "POST",
					headers: {
						"Content-Type": "application/json",
						"Accept":  "application/json",
						"Access-Control-Allow-Origin": "*",
								},
		 };
		 const response = await fetch(ccURL, options);
		 if(response.ok){
				const data = await response.json();
		}
};
export const actAccount= async(activation)  => {
	try {
		const LabID=sessionStorage.getItem("LABID");
		const params = new URLSearchParams({
			labid: LabID,
			});
			// console.log(activation);
			
		const response = await fetch(`${rootDTCAPIURL}activatepatient?${params}`, {
		  method: 'POST',
		  body: JSON.stringify(activation),
		  headers: {
			'Content-Type': 'application/json'
		  }
		});
       if (!response.ok && response.status === 500) { 
			throw json(
			{ message: 'Could not register due to network issue.' },
			{
				status: 500,
			}
			);
	   }
 	   if(response.status === 204 || response.status === 401){
		   return response;
	   } else {
            const data = await response.json();
            return data
		};
	   throw new Error('Network Error', {cause: "error"});
  }catch(error){
        return [];
    }
}

export const getCategories = async (cattype) => {
    try{
		  let labid = sessionStorage.getItem("LABID");
		  let tries = 0;
		  while (!labid && tries < 10) {
			await new Promise((res) => setTimeout(res, 50));
			labid = sessionStorage.getItem("LABID");
			tries++;
		  }
		  if (!labid) {
			throw new Error("LABID not available for getLabConfig");
		  }
        const params = new URLSearchParams({
            labid: labid,
			tier: cattype
        });
        const response = await fetch(`${rootDTCAPIURL}testcategory?${params}`);
  
        if(response.ok){
            return await response.json();
        }

        throw new Error('Network Error', {cause: response.status});
    }catch(error){
        return [];
    }
};
export const getSuperCategory = async(stateCatSubCat,superCat) => {
	for (let i=0; i<superCat.length; i++) {
		if (JSON.stringify(superCat[i].SubCategories) === JSON.stringify(stateCatSubCat)) {
			return superCat[i].Name;
		}	
	}
}
export const getDropDown = async (dropdowntype) => {
    try{
		const LabID = sessionStorage.getItem("LABID");
        const params = new URLSearchParams({
            labid: LabID,
			type: dropdowntype,
        });
		const response = await fetch(`${rootDTCAPIURL}dropdown?${params}`);

        if(response.ok){
            const session =  await response.json();
           return session;
        }

        throw new Error('Network Error', {cause: response.status});
    }catch(error){
        return [];
    }
};
export const getLabConfig = async (labSetting) => {
    try{
		  let labid = sessionStorage.getItem("LABID");
		  let tries = 0;
		  while (!labid && tries < 10) {
			await new Promise((res) => setTimeout(res, 50));
			labid = sessionStorage.getItem("LABID");
			tries++;
		  }
		  if (!labid) {
			throw new Error("LABID not available for getLabConfig");
		  }
        const params = new URLSearchParams({
            labid: labid,
			setting: labSetting,
        });
		const response = await fetch(`${rootDTCAPIURL}labconfiguration?${params}`);

        if(response.ok){
            const session =  await response.json();
			const Value=session.Value;
			// console.log(labSetting,Value);
           return Value;
        }

        throw new Error('Network Error', {cause: response.status});
    }catch(error){
        return [];
    }
};
export const getMenuType = async () => {
    try{
		  let labid = sessionStorage.getItem("LABID");
		  let tries = 0;
		  while (!labid && tries < 10) {
			await new Promise((res) => setTimeout(res, 50));
			labid = sessionStorage.getItem("LABID");
			tries++;
		  }
		  if (!labid) {
			throw new Error("LABID not available for getLabConfig");
		  }
        const params = new URLSearchParams({
            labid: labid,
			setting: 'DTCMENUTYPE',
        });
		let response={};
		if(labid === 'XYZLABS' && (urlType==='HAMBURGER' || sessionStorage.getItem('MENUTYPE')==='HAMBURGER')){
			response.status='override';
			sessionStorage.setItem('MENUTYPE','HAMBURGER')
			return 'HAMBURGER';
		}else{
			response = await fetch(`${rootDTCAPIURL}labconfiguration?${params}`);
			if(response.ok){
				const session =  await response.json();
				const Value=session.Value;
			   return Value;
			}
		}
        throw new Error('Network Error', {cause: response.status});
    }catch(error){
        return [];
    }
};
export const login = async(logindata)  => {
	try {
		const LabID = sessionStorage.getItem("LABID");
		if( LabID === null ){  setupLabID()};
		const params = new URLSearchParams({
			labid: LabID,
			});
		const response = await fetch(`${rootDTCAPIURL}login?${params}`, {
		  method: 'POST',
		  body: JSON.stringify(logindata),
		  headers: {
			'Content-Type': 'application/json'
		  }
		});
       if (!response.ok && response.status === 500) { 
			throw json(
			{ message: 'Could not login due to network issue.' },
			{
				status: 500,
			}
			);
		} 
		if(response.ok){
            const data = await response.json();
            return data;
        }

        throw new Error('Network Error', {cause: "error"});//response.status});
    }catch(error){
        return [];
	}
}
export const ccFailed = async() =>
{
	const LabID = sessionStorage.getItem("LABID");
	const token = sessionStorage.getItem('token');
	//const orderData = sessionStorage.getItem('testsOrdered');
	const testsOrdered = {token: token}
	//refill cart....
	const params = new URLSearchParams({
            labid: LabID,
        });  	  
	const ccauditresponse = await fetch(`${rootDTCAPIURL}order/paymentfailed?${params}`, {
		  method: 'POST',
		  body: JSON.stringify(testsOrdered),
		  headers: {
			'Content-Type': 'application/json'
		  }
	});
}
export const setUpOrder = (orderData) =>
{
		const token = sessionStorage.getItem('token');
	let aaoeArray=[];
	let aaoeArrayTest=[];
	let aaoeidlist = [];
	let aaoeidlist2='';
	let aaoeidlist3='';
	let temp='';
	let QAArray=[];
	let QA='';
	let Q='';
	let A='';
	let ID='';
	let QA2={};
	let tempArray=[];
	for (let i=0;i<orderData.testsAAOE.length; i++) {
		aaoeArrayTest=[];
		temp=orderData.testsAAOE[i];
		if (temp !== '') {
			QAArray=temp.split('","');
			for (let j=0;j<QAArray.length; j++) {
					// console.log(QAArray[j]);
					if(QAArray[j].includes('AaoeID')) {
						aaoeidlist=QAArray[j].split(':');
						aaoeidlist2=aaoeidlist[1];
						aaoeidlist2=aaoeidlist2.replaceAll('}','');
						aaoeidlist2=aaoeidlist2.replaceAll('"','');
						aaoeidlist2=aaoeidlist2.replaceAll('{','');
						ID=aaoeidlist2.split("^");
					}
			} //end find questid
			for (let j=0;j<QAArray.length; j++) {
				QA=QAArray[j].split(":");
				// console.log(ID[j]);
				Q=QA[0].replaceAll("{",'');
				Q=Q.replaceAll('"','');
				Q=Q.replaceAll('"','');
				A=QA[1].replaceAll("}",'');
				A=A.replaceAll('"','');
				A=A.replaceAll('"','');
				if(Q!=='TestCode' && Q!=="AaoeID") {
					QA2={"QUESTION":Q,"SELECTEDANSWER":A,"QUESTID":ID[j]};
					aaoeArrayTest.splice(j,0,QA2);
				}
			} //end for each question
		} //end if
		aaoeArray.splice(i,0,aaoeArrayTest);
	}
	const testArray = [];
	// console.log(aaoeArray);
	for (let i = 0; i < orderData.tests.length; i++) {
	  const testObj = {
		CODE: orderData.tests[i],
	  };
		const aaoe = aaoeArray[i];

		if (
		  Array.isArray(aaoe) &&
		  aaoe.length > 0 &&
		  !(aaoe[0].QUESTION === 'none' && aaoe[0].SELECTEDANSWER === 'none')
		) {
		  testObj.AAOES = aaoe;
		}
 	    testArray[i] = testObj;
	}

	const testsOrdered = {TOKEN: token, TESTS: testArray}
	sessionStorage.setItem('testsOrdered',JSON.stringify(testsOrdered));
	return testsOrdered;
}

export const checkout = async(orderData) =>
{
	//audit order in case payment succeeds but order isn't placed
	const LabID = sessionStorage.getItem("LABID");
	const testsOrdered=setUpOrder(orderData);
	const params = new URLSearchParams({
            labid: LabID,
        });  
		
	const ccauditresponse = await fetch(`${rootDTCAPIURL}audit/order?${params}`, {
		  method: 'POST',
		  body: JSON.stringify(testsOrdered),
		  headers: {
			'Content-Type': 'application/json',							
		  }
	});
	
	const ref_id=LabID.concat(":",sessionStorage.getItem("Labtestid"));
	let DTCURL = await getLabConfig("DTCWEBSERVER");
	let DTCBACKENDSERVER = await getLabConfig("DTCBACKENDSERVER");
	const DTCCCProvider = await getLabConfig("DTCCCPROVIDER");
	let ccURL='';
	let MXURL='';
	let options='';
	let i=0;
	let testarray=[];
	let totalamt=0;
	const tests=orderData.testNames;
	const amounts=orderData.amount;
	if (process.env.NODE_ENV !== 'production' ){
		DTCURL = "http://localhost:3000";
		DTCBACKENDSERVER = "http://localhost:4242";
	}
	const profile=await getUserProfile(sessionStorage.getItem('Labtestid'));
	let DOB2=profile.DOB;
	const DOB=convertDate(DOB2);
	const orderdate2= new Date();
	const orderdate=convertDate2(orderdate2);
	let itemamt=0;
	let itemamt2=0;

	const CCC = await getLabConfig("DTCCCCREDENTIALS");
	const CCCobj = JSON.parse(CCC);

	if(DTCCCProvider ===  'REVSPRING') {
		const RSUN=CCCobj.USERNAME;
		const RSPW = CCCobj.PASSWORD;
		const RSSite = CCCobj.SITE;
		const cid=profile.ClientMnemonic + "-" + profile.PID;
		const acct = 'RM.' + profile.ClientMnemonic
		for (let i=0;i<amounts.length;i++) {	
		itemamt2=Number(amounts[i]);
		itemamt=itemamt2.toFixed(2);
			testarray[i]={
				"AmountDue": itemamt,
				"AccountNumber": acct,
				"FirstName": profile.PatientFirstName,
                "LastName": profile.PatientLastName
				}
				totalamt += Number(amounts[i]);
		};
			const slicebody= {
			"Payload": {
				    "Username": RSUN,
					"Password": RSPW,
					"ConsumerNumber": cid,
					"OrgSiteName": RSSite,
					"GroupSiteName": RSSite,
					"DeepLink": "AccountSummary",
					"ConsumerEmail": profile.PatEmail,
					"ConsumerFirstName": profile.PatientFirstName,
					"ConsumerLastName": profile.PatientLastName,
					"DataContext": {
					  "Consumer": {
						"client_reference_id": ref_id,
						"FirstName": profile.PatientFirstName,
						"LastName": profile.PatientLastName,
						"Address1": profile.Address,
						"Address2": "",
						"City": profile.City,
						"State": profile.State,
						"Country": "US",
						"Zip": profile.Zip,
						"DateOfBirth": DOB,
						"Email": profile.PatEmail,
						"AmountDue": totalamt.toFixed(2),
						"AmountDueAsOf": orderdate
					  },
					"LineItem": testarray
				}
			}
		};
		//call revspring
		 ccURL=`${DTCBACKENDSERVER}/revspring/create-checkout`;
		 options= { method: "POST",
					headers: {
						"Content-Type": "application/json",
						"Accept":  "application/json",
						"Access-Control-Allow-Origin": "*",
								},

					body: JSON.stringify(slicebody),
		 };
	}else if(DTCCCProvider ===  'CLOVER') {
		const cid=profile.ClientMnemonic + "-" + profile.PID;
		while (i<amounts.length) {	
		itemamt2=Number(amounts[i]);
		itemamt=itemamt2*100;
			testarray[i]={
				"price": itemamt,
				"name": tests[i].replaceAll("^",","),
				"unitQty" : 1
				}
				totalamt += Number(amounts[i]);
			i++;
		};
			const slicebody= {
					"amount": totalamt,
					"currency":"USD",
					"customer": {						
						"note": ref_id,
						"firstName": profile.PatientFirstName,
						"lastName": profile.PatientLastName,
						"email": profile.PatEmail
						},
					"redirectUrls": {
						"success": `${DTCURL}/orderSuccessful`,
						"failure": `${DTCURL}/creditCardFailed`,
						"cancel": `${DTCURL}/creditCardFailed`,
					},
					"shoppingCart": {
						"lineItems": testarray
					}

		};

		const CloverIFrame = '/creditCardiFrameCLOVER/'+totalamt+'/'+profile.PatEmail+'/'+profile.PatientFirstName+'/'+profile.PatientLastName+'/'+ref_id
		// console.log(CloverIFrame);
		window.location.replace(CloverIFrame);
		//call CLOVER for hosted checkout
		// ccURL=`${DTCBACKENDSERVER}/clover/create-checkout`;
		// options= { method: "POST",
		//			headers: {
		//				"Content-Type": "application/json",
		//				"Accept":  "application/json",
		//				"Access-Control-Allow-Origin": "*"
		//				},
		//				body: JSON.stringify(slicebody),
		// };
	}else if(DTCCCProvider === 'MXMERCHANT') {
		for (let i=0;i<amounts.length;i++) {	
			itemamt2=Number(amounts[i]);
			itemamt=itemamt2.toFixed(2);
			testarray[i]={
				"AmountDue": itemamt,
				"AccountNumber": tests[i].replaceAll("^",","),
				"FirstName": profile.PatientFirstName,
                "LastName": profile.PatientLastName
				}
				totalamt += Number(amounts[i]);
		};
		MXURL=CCCobj.URL;
		if (process.env.NODE_ENV !== 'production') {
			MXURL = process.env.REACT_APP_MXMERCHANT;
		}

		MXURL = MXURL +'?amt='+totalamt.toFixed(2);
		MXURL = MXURL +'&Address='+profile.Address;
		MXURL = MXURL +'&City='+profile.City;
		MXURL = MXURL +'&State='+profile.State;
		MXURL = MXURL +'&Zip='+profile.Zip;
		MXURL = MXURL +'&CustomerName='+profile.PatientFirstName+' '+profile.PatientLastName;
		MXURL = MXURL +'&Email='+profile.PatEmail;
		MXURL = encodeURI(MXURL);
	}else if(DTCCCProvider === 'XIFIN') {
		for (let i=0;i<amounts.length;i++) {	
			itemamt2=Number(amounts[i]);
			itemamt=itemamt2.toFixed(2);
			testarray[i]={
				"AmountDue": itemamt,
				"AccountNumber": tests[i].replaceAll("^",","),
				"FirstName": profile.PatientFirstName,
                "LastName": profile.PatientLastName
				}
				totalamt += Number(amounts[i]);
		};
	}else if(DTCCCProvider ===  'TOUCHNET') {
		for (let i=0;i<amounts.length;i++) {	
			itemamt2=Number(amounts[i]);
			itemamt=itemamt2.toFixed(2);
			testarray[i]={
				"AmountDue": itemamt,
				"AccountNumber": tests[i].replaceAll("^",","),
				"FirstName": profile.PatientFirstName,
                "LastName": profile.PatientLastName
				}
				totalamt += Number(amounts[i]);
		};

		const slicebody= {
				"ticketName": ref_id,
				"nameValuePairs": [
					{"name":"AMT",
					 "value":Number(totalamt).toFixed(2)
					},
					{"name":"BILL_NAME",
					 "value": profile.PatientFirstName + " " + profile.PatientLastName
					},
					{"name":"BILL_EMAIL_ADDRESS",
					 "value": profile.PatEmail
					},
					{"name":"BILL_STREET1",
					 "value": profile.Address
					 },
					{"name":"BILL_CITY",
					  "value": profile.City
					},
					{"name": "BILL_STATE",
  					  "value": profile.State
					},
					{"name":"BILL_POSTAL_CODE",
					  "value":profile.Zip
					},
					{"name":"EXT_TRANS_ID",
					  "value": ref_id
					},
					{"name":"CANCEL_LINK",
					  "value" :`${DTCURL}/creditCardFailed`
					},
					{"name":"ERROR_LINK",
					 "value" :`${DTCURL}/creditCardFailed`
					},
					{"name": "SUCCESS_LINK",
					  "value": `${DTCBACKENDSERVER}/touchnet/authorization`
					},
					{"name": "LP_LINK",
						"value": `${DTCURL}/orderSuccessful`
					}
				]
			};
		//call touchnet
		 ccURL=`${DTCBACKENDSERVER}/touchnet/create-Ticket`;
		 options= { method: "POST",
					headers: {
						"Content-Type": "application/json",
						"Accept":  "application/json",
						"Access-Control-Allow-Origin": "*",
								},
		
				body: JSON.stringify(slicebody),
		 };
	 }else{
		 //set up Stripe payment information

		while (i<amounts.length) {	
			testarray[i]={
				"price_data": {
					"unit_amount": amounts[i]*100,
					"currency": "usd",
					"product_data": {
						"name": tests[i].replaceAll("^",","),
					}
				},
				"quantity": "1"
				}
			i++;
		};
		const slicebody= {
		  "mode": "payment",
		  "allow_promotion_codes":"true",
		  "customer_email":profile.PatEmail,
		  "client_reference_id":ref_id,
		  "line_items": testarray,
		  "cancel_url": `${DTCURL}/creditCardFailed`,
		  "success_url": `${DTCURL}/orderSuccessful?session_id={CHECKOUT_SESSION_ID}`
		};
		//call stripe
		 ccURL=`${DTCBACKENDSERVER}/stripe/create-checkout-session-via-fetch`;
		 options= { method: "POST",
							headers: {
								"Content-Type": "application/json",
								"Accept":  "application/json",
								"Access-Control-Allow-Origin": "*"
							  },
							body: JSON.stringify(slicebody),
		 };
	 }
	// try {
		if(DTCCCProvider === 'MXMERCHANT'){
			// console.log('mxmerchant');
			// console.log(MXURL);
			window.location.replace(MXURL);
		}else if(DTCCCProvider === 'XIFIN'){
			// console.log('XIFIN');
			const xifin={};
			xifin.type='xifin';
			xifin.amount=totalamt.toFixed(2);
			xifin.address=profile.Address;
			xifin.firstname=profile.PatientFirstName;
			xifin.lastname=profile.PatientLastName;
			xifin.postalcode=profile.Zip;
			return({xifin});
		/*}else if(DTCCCProvider === 'CLOVER') {
			console.log(amounts,amounts.length);
			for (let i=0;i<amounts.length;i++) {	
				itemamt2=Number(amounts[i]);
				itemamt=itemamt2*100;
				console.log(itemamt);
				totalamt += Number(amounts[i]);
				};
			const CloverIFrame = '/creditCardiFrameCLOVER/'+totalamt
			console.log(CloverIFrame);
			window.location.replace(CloverIFrame);*/
		}else{
			 const response = await fetch(ccURL, options);
			 if(response.ok){
					const data = await response.json();
					if(DTCCCProvider ===  'REVSPRING') {
						// console.log("revspring return");
						const revspringReturn='{"RevSpringToken":"'+data.session.WebTokenId+'"}'
						return(revspringReturn);
					/*}if(DTCCCProvider ===  'CLOVER') {
						console.log("clover");
						sessionStorage.setItem("CloverID",data.session.checkoutSessionId)
						const cloverReturn='{"CloverID":"'+data.session.checkoutSessionId+'"}'
						return(cloverReturn);
						//window.location.replace(data.session.href);*/
					} else if(DTCCCProvider ===  'TOUCHNET') {
						sessionStorage.setItem('Ticket',data.ticket);
						sessionStorage.setItem('Labid',LabID);
						 window.location.replace('TouchNet');
					}else{
						window.location.replace(data.session.url);
					}
			 }
		}
	//	throw new Error('Network Error', {cause: "error"});//response.status});
    //}catch(error){
		//console.log(error);
	//	if (error) {
		//	alert(error);
		//	alert("Credit Card payment is not set up");
		//	return ("Credit Card Error");
	//	}
    //}
}

export const order = async(orderData,ccID) => {
    try{
	  const LabID = sessionStorage.getItem("LABID");
      const params = new URLSearchParams({
            labid: LabID,
        });
	  const token = sessionStorage.getItem('token');
	  let testsOrdered = JSON.parse(orderData);
	  // console.log(testsOrdered);
	  testsOrdered.CCID = ccID;
	  let reqnumbers = '';
	  const response = await fetch(`${rootDTCAPIURL}order/submit?${params}`, {
		  method: 'POST',
		  body: JSON.stringify(testsOrdered),
		  headers: {
			'Content-Type': 'application/json'
		  }
		});
        if(response.status === '204'){
			console.log('204');
			const reqData={"Error":"No credit card authorization received."};
			return reqData;
		}
		if (!response.ok) {
		  const errText = await response.text().catch(() => "");
		  throw new Error(`HTTP ${response.status} ${response.statusText || ""} ${errText}`);
		}
		const contentType = response.headers.get('content-type') || '';
		if (contentType.includes('application/json')) {
		  const text = await response.text();           // read once
		  const data = text ? JSON.parse(text) : null;  // guard empty
			const reqinfo = {};
			const reqnumbersArray = [];
			const reqStatusArray = [];

			const promises = data['ROWS'].map(async (element) => {
				const reqNum = element[0];
				const status = element[88];
				reqnumbersArray.push(reqNum);
				reqStatusArray.push(status);
				reqinfo[reqNum] = await getOrderInfo(reqNum); // Await the async result
			});

			await Promise.all(promises); // Wait for all getOrderInfo calls to finish

			const reqnumbers = reqnumbersArray.join(','); // Comma-separated string
			const reqStatus = reqStatusArray.join(',');

			const reqData={reqnum: reqnumbers, reqinfo: reqinfo, status: reqStatus };
			sessionStorage.removeItem('ccID');
			sessionStorage.removeItem('testsOrdered');
            return reqData;
		} else {
		  const text = await response.text();
		  console.log('Non-JSON body:', text);
		  return { Error: 'No req number returned' };
		}
		
        throw new Error('Network Error', {cause: "error"});//response.status});
    }catch(error){
        return {};
    }
};
export const orderValidation = async(orderData) => {
    try{
	  const LabID = sessionStorage.getItem("LABID");
  	  const token = sessionStorage.getItem('token');
      const params = new URLSearchParams({
            labid: LabID,
        });

	  const testsOrdered = {tests: orderData, token: token}
	  
	  const response = await fetch(`${rootDTCAPIURL}order/validate?${params}`, {
		  method: 'POST',
		  body: JSON.stringify(testsOrdered),
		  headers: {
			'Content-Type': 'application/json'
		  }
		});
        if(response.ok){
            const data = await response.json();
			
            return data;
        }
		
        throw new Error('Network Error', {cause: "error"});//response.status});
    }catch(error){
		console.log("validation error");
        return {};
    }
};
export const getOrdersPending = async() => {
    try{
	  const LabID = sessionStorage.getItem("LABID");
	  const token = sessionStorage.getItem('token');
      const params = new URLSearchParams({
            labid: LabID,
			token: token,
        });
		let data={};
		let appt={};
	  const response = await fetch(`${rootDTCAPIURL}order?${params}`);
        if(response.ok && response.status === 200){
            data = await response.json();
			const newData = await Promise.all(
			  data.map(async (penOrder) => {
				const appt = await getAppointment(penOrder.ReqNumber);
				const first = appt?.[0]; // safely get element 0

				return {
				  ...penOrder,
				  apptLocation: first?.Location ?? null,
				  apptTime: first?.StartTime ?? null,
				};
			  })
			);

            return newData;
        }else if (response.ok && response.status === 204){
			data="no pending orders"
			return data;
		}

        throw new Error('Network Error', {cause: "error"});//response.status});
    }catch(error){
		console.log(error);
        return [];
    }
};
export const getAppointment = async (req) => {
	try{
		const LabID = sessionStorage.getItem("LABID");
        let params = new URLSearchParams({
            labid: LabID,
			token: sessionStorage.getItem("token"),
			requisition: req
        });
		if(sessionStorage.getItem("token") ===  null & sessionStorage.getItem("sstoken") !== null & sessionStorage.getItem("labtestid") !== null &sessionStorage.getItem("sstoken") !== undefined & sessionStorage.getItem("labtestid") !== undefined) {
			params = new URLSearchParams({
				labid: LabID,
				sstoken: sessionStorage.getItem("sstoken"),
				labtestid: sessionStorage.getItem("labtestid"),
				requisition: req
			});
		}
		const response = await fetch(`${rootSHAPIURL}appointment?${params}`);

        if(response.ok){
            const session =  await response.json();

				const upcoming = session
				  .map(item => ({
					...item,
					StartTime: formatDisplayDate(new Date(item.StartTime)),
					EndTime: formatDisplayDate(new Date(item.EndTime)),
				  }));
           return upcoming;
        }

        throw new Error('Network Error', {cause: response.status});
    }catch(error){
        return [];
    }
};
export const getOrderInfo = async(reqnumber) => {
    try{
	  const LabID = sessionStorage.getItem("LABID");
      const params = new URLSearchParams({
            labid: LabID,
			requisition: reqnumber,
        });
		let data={};
	  const response = await fetch(`${rootDTCAPIURL}order/info?${params}`);
        if(response.ok && response.status === 200){
            data = await response.json();
            return data;
		}

        throw new Error('Network Error', {cause: "error"});//response.status});
    }catch(error){
		console.log(error);
        return [];
    }
};
export const getOrderStatus = async(reqnumber) => {
    try{
	  const LabID = sessionStorage.getItem("LABID");
      const params = new URLSearchParams({
            labid: LabID,
			requisition: reqnumber,
        });
		let data={};
	  const response = await fetch(`${rootDTCAPIURL}order/status?${params}`);
        if(response.ok && response.status === 200){
            data = await response.json();
            return data.status;
		}

        throw new Error('Network Error', {cause: "error"});//response.status});
    }catch(error){
		console.log(error);
        return [];
    }
};
export const forgotPassword = async(resUsername) => {
	try {
		const LabID = sessionStorage.getItem("LABID");
		const params = new URLSearchParams({
			labid: LabID,
			});
		const response = await fetch(`${rootDTCAPIURL}resetpasswordemail?${params}`, {
		  method: 'POST',
		  body: JSON.stringify(resUsername),
		  headers: {
			'Content-Type': 'application/json'
		  }
		});
       if (!response.ok && response.status === 500) { 
			throw json(
			{ message: 'Could not reset password to network issue.' },
			{
				status: 500,
			}
			);
		} 

		if(response.ok){
            return response;
        }

        throw new Error('Network Error', {cause: "error"});//response.status});
    }catch(error){
        return [];
	}
}
export const updatePassword = async(passwordData)  => {
	try {
		const LabID = sessionStorage.getItem("LABID");
		const params = new URLSearchParams({
			labid: LabID,
			});
		const response = await fetch(`${rootDTCAPIURL}resetpassword?${params}`, {
		  method: 'POST',
		  body: JSON.stringify(passwordData),
		  headers: {
			'Content-Type': 'application/json'
		  }
		});
       if (!response.ok && response.status === 500) { 
			throw json(
			{ message: 'Could not update password due to network issue.' },
			{
				status: 500,
			}
			);
	   }
 	   if(response.status === 204 || response.status === 401){
		   return response;
	   } else {
            const data = await response.json();
            return data
		};
	   throw new Error('Network Error', {cause: "error"});
  }catch(error){
        return [];
    }
}

export const addRegistration= async(registration)  => {
	try {
		const LabID = sessionStorage.getItem("LABID");
		const params = new URLSearchParams({
			labid: LabID
			});
		const response = await fetch(`${rootDTCAPIURL}registerpatient?${params}`, {
		  method: 'POST',
		  body: JSON.stringify(registration),
		  headers: {
		 'Content-Type': 'application/json'
		  }
		});
		if (!response.ok && response.status === 500) { 
			throw json(
			{ message: 'Could not register due to network issue.' },
			{
				status: 500,
			}
			);
		} else {
			return response;
		}
	   throw new Error('Network Error', {cause: "error"});
  }catch(error){
        return [];
    }
}
export const getTableForm = async(section,item) => {
    try{
		  let labid = sessionStorage.getItem("LABID");
		  let tries = 0;
		  while (!labid && tries < 10) {
			await new Promise((res) => setTimeout(res, 50));
			labid = sessionStorage.getItem("LABID");
			tries++;
		  }
		  if (!labid) {
			throw new Error("LABID not available for getLabConfig");
		  }
      const params = new URLSearchParams({
            labid: labid,
			section: section,
			item: item,
        });
	  const compareSort = (a,b)=>  {
		  return a.TFOrder-b.TFOrder;
	  };
	  const response = await fetch(`${rootDTCAPIURL}tableform?${params}`);
        if(response.ok){
            const data = await response.json();
			let newData = data.filter(x => x.Display);
			let newData2 = newData.map(obj => ({...obj,key: obj.TFOrder}));
			let newData3 = newData2.sort(compareSort);
            return newData3;
        }

        throw new Error('Network Error', {cause: "error"});//response.status});
    }catch(error){
        return [];
    }
};
export const getTests = async (
  page,
  testsPerPage,
  sortBy = '',
  searchTerm = '',
  categories = []
) => {
  try {
    let labid = sessionStorage.getItem("LABID");
    let tries = 0;
    while (!labid && tries < 10) {
      await new Promise((res) => setTimeout(res, 50));
      labid = sessionStorage.getItem("LABID");
      tries++;
    }

    if (!labid) {
      throw new Error("LABID not available for getTests");
    }

    const parsedPaging = parseInt(testsPerPage, 10);

    const resolvedPaging = !isNaN(parsedPaging) && parsedPaging > 0
      ? parsedPaging
      : parseInt(await getLabConfig("DTCPAGING", labid), 10) || 10;

    if (page === 'undefined' || typeof page === 'undefined') page = 1;

    const params = new URLSearchParams({
      labid,
      page,
      recordsperpage: resolvedPaging,
      searchterm: searchTerm.trim(),
      sort: sortBy,
      categories: categories.join(',')
    });

    const response = await fetch(`${rootDTCAPIURL}test?${params.toString()}`);

    if (response.ok) {
      return await response.json();
    }

    throw new Error('Network Error', { cause: response.status });

  } catch (error) {
    console.error("❌ getTests failed:", error);
    return {
      tests: [],
      totalTests: 0,
      page: 0,
      error: error.cause || error.message
    };
  }
};


export const getTestInfo = async (testID) => {
    try{
		  let labid = sessionStorage.getItem("LABID");
		  let tries = 0;
		  while (!labid && tries < 10) {
			await new Promise((res) => setTimeout(res, 50));
			labid = sessionStorage.getItem("LABID");
			tries++;
		  }
		  if (!labid) {
			throw new Error("LABID not available for getLabConfig");
		  }
        const params = new URLSearchParams({
            labid: labid,
            testid: testID
        });
        const response = await fetch(`${rootDTCAPIURL}testinfo?${params}`);

        if(response.ok){
            const data = await response.json();
            return data[0];
        }

        throw new Error('Network Error', {cause: response.status});
    }catch(error){
        return {
            tests: [],
            totalTests: 0,
            error: error.cause
        };
    }
};

export const getAAOE = async (testID) => {
    try{
		const LabID = sessionStorage.getItem("LABID");
        const params = new URLSearchParams({
            labid: LabID,
            test: testID
        });

        const response = await fetch(`${rootDTCAPIURL}test/aaoe?${params}`);

        if(response.ok){
 			const data = await response.json();
            return data;
        }

        throw new Error('Network Error', {cause: response.status});
    }catch(error){
        return {
           
            error: error.cause
        };
    }
};
export const getAAOEAnswers = async (aaoeAnswers,aaoeQuestions) => {
    try{
		const questList = aaoeAnswers['AaoeID'].split("^");
		let data=[];
		for (let i=0;i<aaoeQuestions.length; i++) {
			const QID=aaoeQuestions[i].QuestID.toString();
			const QName=aaoeQuestions[i].Name;
			const index=questList.indexOf(QID);
			const Answer=aaoeAnswers[QName];
			data[index]=Answer
		}
		return data;

        throw new Error('Network Error', {cause: 'no answers'});
    }catch(error){
        return {
           
            error: error.cause
        };
    }
};
export const getRequiredTests = async () => {
	try{
		let reqTestInfo = [];
		let reqTestInfoAll = [];
		let reqTestInfo2 = [];
		const reqTests = await getLabConfig("DTCREQUIREDTEST");
			if (reqTests !== '') {
				const testArray=reqTests.split(",");
				for (let i=0; i< testArray.length; i++) {
					reqTestInfo[i] = await getTestInfo(testArray[i]);
				};
			}
		reqTestInfoAll=reqTestInfo
		const reqStTests = await getLabConfig("DTCSTCONDTEST");
		if (reqStTests !== null && reqStTests !== undefined && sessionStorage.getItem("token")) {
			const up= await getUserProfile();
			console.log(up);
			const stdd = await getDropDown("DTCSTATES");
			const stlist = stdd.map(o=>o.DropDownCode);
			if(reqStTests==="CANNOT ORDER" && !stlist.includes(up.State) ){
				return "CANNOT ORDER"
			}
			if(reqStTests==="WARNING" && !stlist.includes(up.State) ){
				return "WARNING"
			}
			if(!stlist.includes(up.State)) {
				const testArray2=reqStTests.split(",");
				for (let i=0; i< testArray2.length; i++) {
					reqTestInfo2[i] = await getTestInfo(testArray2[i]);
				};
			}
			reqTestInfoAll=reqTestInfo.concat(reqTestInfo2);
		}
				console.log(reqTestInfoAll);
		return reqTestInfoAll;

        throw new Error('Network Error', {cause: 'no answers'});
    }catch(error){
        return {
           
            error: error.cause
        };
    }
};
export const getSystemMsg = async (msgType) => {
    try{
		  let labid = sessionStorage.getItem("LABID");
		  let tries = 0;
		  while (!labid && tries < 10) {
			await new Promise((res) => setTimeout(res, 50));
			labid = sessionStorage.getItem("LABID");
			tries++;
		  }
		  if (!labid) {
			throw new Error("LABID not available for getLabConfig");
		  }
        const params = new URLSearchParams({
            labid: labid,
            type: msgType,
        });
        const response = await fetch(`${rootDTCAPIURL}systemmessage?${params}`);
        
        if(response.ok){
            const data = await response.json();
			let TodaysDate = new Date();
			if (data.Type === msgType && data.Active === "1" && data.Message !== '' && (TodaysDate <= new Date(data.ExpirationDate) || data.ExpirationDate === '' || typeof(data.ExpirationDate) == "undefined")) {
				return data.Message;
			}
			else
			{
            return [];
			}
        }

        throw new Error('Network Error', {cause: response.status});
    }catch(error){
        return {

        };
    }
};
export const forgotUsername = async(usernameData) => {
	try {
		const LabID = sessionStorage.getItem("LABID");
		const params = new URLSearchParams({
			labid: LabID,
			});
		const response = await fetch(`${rootDTCAPIURL}getusername?${params}`, {
		  method: 'POST',
		  body: JSON.stringify(usernameData),
		  headers: {
			'Content-Type': 'application/json'
		  }
		});
       if (!response.ok && response.status === 500) { 
			throw json(
			{ message: 'Could not retrieve username to network issue.' },
			{
				status: 500,
			}
			);
		} 
		if(response.ok){
            return response;
        }

        throw new Error('Network Error', {cause: "error"});//response.status});
    }catch(error){
        return [];
	}
}
export const getUserProfile = async() => {
    try{
	  const LabID = sessionStorage.getItem("LABID");
	  const token = sessionStorage.getItem('token');
      const params = new URLSearchParams({
            labid: LabID,
			token: token,
        });
	  const response = await fetch(`${rootDTCAPIURL}getpatient?${params}`);
		if(response.ok){
            const data = await response.json();
            return data;
        }

        throw new Error('Network Error', {cause: "error"});//response.status});
    }catch(error){
        return [];
    }
};
export const updateUserProfile = async(userData) => {
    try{
  	  const LabID = sessionStorage.getItem("LABID");
      const params = new URLSearchParams({
            labid: LabID
        });
	  userData.token = sessionStorage.getItem('token');
	  const response = await fetch(`${rootDTCAPIURL}updatepatient?${params}`, {
		  method: 'POST',
		  body: JSON.stringify(userData),
		  headers: {
			'Content-Type': 'application/json'
		  }
		});
        if(response.ok){
            return response;
        }

        throw new Error('Network Error', {cause: "error"});//response.status});
    }catch(error){
        return [];
    }
};

